import React from 'react';
import { ChristmasSectionHeading } from './ChristmasSectionHeading';
import { whyChooseItems } from '../../../data/christmasPage';
import { christmasQuoteHref } from '../../../data/christmasContacts';
export function ChristmasWhyChooseSection() {
  return <section id="christmas-why" aria-labelledby="christmas-why-title" className="scroll-mt-32 bg-forest py-20 text-white md:py-28" data-id="element-268" data-mp="2vn2klzxze24e">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-269" data-mp="2ml33z8qvp01z">
        <ChristmasSectionHeading eyebrow="Why Choose Us" title={<>
              Why choose <span className="italic text-[#E3C77F]" data-id="element-271" data-mp="2hs098xad7kk7">Chacon’s</span> for your holiday lights?
            </>} titleId="christmas-why-title" tone="light" data-id="element-270" data-mp="2mmnwytxjoaxq" />
        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-272" data-mp="27tkhcs3ik79n">
          {whyChooseItems.map(({
          title,
          description,
          icon: Icon
        }) => <li key={title} className="flex gap-4 rounded-3xl bg-white/[0.06] p-6 ring-1 ring-white/10" data-id="element-273" data-mp="1yuqlx51x5mxo">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#E3C77F]/15 text-[#E3C77F]" data-id="element-274" data-mp="22vlkqgd8hi1q">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-275" data-mp="27oo7o5ni9t8y" />
              </span>
              <div data-id="element-276" data-mp="1szs3wkshf2e5">
                <h3 className="font-display text-xl" data-id="element-277" data-mp="1swdx90csc70w">{title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-white/70" data-id="element-278" data-mp="1xylf26kaqhb5">{description}</p>
              </div>
            </li>)}
        </ul>
        <div className="mt-12 text-center" data-id="element-279" data-mp="2qm7h3advldvw">
          <a href={christmasQuoteHref} className="inline-flex h-14 items-center justify-center rounded-full bg-[#E3C77F] px-8 text-[13px] font-bold uppercase tracking-[0.08em] text-forest-900 transition-colors hover:bg-white" data-id="element-280" data-mp="2ql62wx1kcb9y">
            Get a Free Estimate
          </a>
        </div>
      </div>
    </section>;
}